import { useEffect } from 'react';
import { useSessionStoragePersistedState } from 'src/services/storage/hooks/useSessionStoragePersistedState';
import { AUTH_EVENT_TYPES } from '../../events/constants';
import { useAuthEvents } from '../../hooks/useAuthEvents';
import { useZillowSession } from '../../hooks/useZillowSession';
import { SessionStatus } from '../../constants';

/**
 * This hook provides the state management for powering a logout banner experience
 * @param sessionKey The session storage key for persisting logout banner state (since it must survive across page loads)
 */
export const useLogoutBannerState = (sessionKey: string) => {
    const [shouldRender, setShouldRender] = useSessionStoragePersistedState(sessionKey, false);
    const { status } = useZillowSession();
    const { getLatestEvent } = useAuthEvents([AUTH_EVENT_TYPES.LOGIN, AUTH_EVENT_TYPES.LOGOUT]);
    useEffect(() => {
        const { event, consumeEvent } = getLatestEvent();
        if (event === AUTH_EVENT_TYPES.LOGOUT) {
            setShouldRender(true);
            consumeEvent();
        } else if (event === AUTH_EVENT_TYPES.LOGIN) {
            setShouldRender(false);
            consumeEvent();
        }
    }, [getLatestEvent, setShouldRender]);
    return {
        shouldRender: status !== SessionStatus.AUTHENTICATED && shouldRender,
        setShouldRender,
    };
};
